'use strict'

import { Editor } from 'tiptap'
import { BulletList, OrderedList, ListItem, Bold, Italic, Strike, Underline, History, Focus, Placeholder, Heading } from 'tiptap-extensions'
import Image from '~/lib/tipTapCustom-image'
import Link from '~/lib/tipTapCustom-link'
import Video from '~/lib/tipTapCustom-video'
import ReplaceWithNode from '~/lib/tipTapCustom-replaceWithNode'

export default function ({ isReadOnly = false, args = {} } = {}) {
   // args.useBuiltInExtensions = false
   let extensions = [
      // new Doc(),
      // new Text(),
      // new Paragraph(),
      new BulletList(),
      new OrderedList(),
      new ListItem(),
      new Bold(),
      new Italic(),
      new Strike(),
      new Underline(),
      new History(),
      new Focus({
         className: 'is-focused',
      }),
      // Custom nodes
      new Link(),
      new Video(),
      new Heading(),
      // TODO: The `isReadOnly` here can be deleted
      new Image({ isReadOnly }),
      new ReplaceWithNode(),
   ]

   // if (!isReadOnly) {
   //    extensions.push(
   //       new TrailingNode({
   //          node: 'paragraph',
   //          notAfter: ['paragraph'],
   //       }),
   //    )
   // }
   if (isReadOnly) {
      args.editable = false
   }

   //
   // Handle disabling some paste rules
   //
   const maybeDisabledPasteRules = ['heading', 'bold', 'italic', 'link', 'bullet_list', 'ordered_list', 'image', 'video']
   let disabledPasteRules = maybeDisabledPasteRules.filter(rule => !args.allowedActions.includes(rule))
   // Always disable the `heading`, since there's no way to distinguish between an `h1`, `h2`, or `h3`, etc... this should prevent us from ever getting an unwanted `h1` or `h2`.
   if (!disabledPasteRules.includes('heading')) disabledPasteRules.push('heading')
   args.disablePasteRules = disabledPasteRules

   //
   // Handle disabling some input rules
   //
   const maybeDisabledInputRules = ['heading', 'bold', 'italic', 'link', 'bullet_list', 'ordered_list', 'image', 'video']
   let disabledInputRules = maybeDisabledInputRules.filter(rule => !args.allowedActions.includes(rule))
   args.disableInputRules = disabledInputRules

   args.extensions = extensions

   return new Editor(args)
}
